<template>
  <div class="EmailRecoveryPopup">
    <div class="overlay" @click="close"></div>
    <div class="wrapper">
      <img v-if="this.failure" src="@/assets/images/failure.svg" />
      <img v-else src="@/assets/images/success.svg" />
      <h1 v-if="this.failure" class="font-size-big">Niepowodzenie</h1>
      <h1 v-else class="font-size-big">Sukces</h1>
      <h2 class="font-size-middle">{{title}}</h2>
      <button v-if="this.failure" class="font-size-middle failure" @click="close">OK</button>
      <button v-else class="font-size-middle success" @click="close">OK</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmailRecoveryPopup",

  props: {
    title: {
      type: String,
      required: true,
    },
    failure: {
      type: Boolean,
      required: false,
    }
  },

  methods: {
    close() {
      this.$router.push({ name: "logInPage" });
    },
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.EmailRecoveryPopup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100vh;
  top:0;
  z-index: 3;
}

.overlay {
  z-index: 1;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
}

.wrapper {
  position: absolute;
  z-index: 6;
  width: 500px;
  height: 200px;
  background: black;
  border: solid 1px $white;
  border-radius: 0.5rem;
  h1 {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 10px;
  }
  h2 {
    text-align: center;
    font-weight: normal;
    padding: 0 20px;
  }
  button {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    height: 40px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;

    &.success {
      background-color: #8bc34a;
    }

    &.failure {
      background-color: #db4437;
    }
  }
  img {
    position: absolute;
    left: 50%;
    top: 0;
    width: 200px;
    height: 100px;
    margin-left: -100px;
    margin-top: -50px;
  }
}

@media only screen and (max-width: $phone-max-width) {
  .wrapper {
    width: 90%;
  }
}
</style>
